import React from "react";
import Header from "../components/Header";
import Banner from "../components/Banner";
import Footer from "../components/Footer";
import ScrollToTopButton from "../components/ScrollTop";
import WhatsAppMsg from "../components/WhatsApp";

const GetQuote = () => {
  return (
    <>
      <div className="about-us-page">
        <Header />
      </div>
      <Banner
        imgSrc="https://content.qeeb.in/coltec/quote-now-banner-image.webp"
        altText="Get the Best Price for COLTEC Display Technology Solutions!"
        bannerHeight="md:h-[520px] h-[275px]"
        imgHeight="md:inset-auto object-contain pt-[2.5rem] md:h-[470px] md:pt-0 h-[275px]"
        heading="Get the Best Price for COLTEC Display Technology Solutions!"
        headClasses="md:block text-center hidden max-w-2xl text-[21px] font-semibold tracking-tight leading-[1.7] text-white sm:text-4xl drop-shadow-lg mt-3"
        opacityClasses="opacity-layer absolute inset-0 w-full md:h-full h-[300px] bg-neutral-liner z-0"
        paragraphText="Looking for high-performance display technology products and solutions? Connect with us to get a customized quote tailored to your needs."
        positionClasses="absolute md:bottom-32 bottom-12 left-0 lg:inset-x-0 flex"
        headerTextClasses="text-[29px] md:text-4xl max-w-2xl text-white font-medium leading-10"
        paragraphTextClasses="md:text-base text-center md:block hidden text-sm text-white max-w-2xl mt-4"
      />
      <div className="md:hidden block px-6 py-8 bg-gray-50">
        <h2 className="w-[362px] relative justify-start text-black mb-4 text-xl font-medium font-['Poppins'] leading-tight">
          Get the Best Price for COLTEC Display Technology Solutions!
        </h2>
        <p className="max-w-[373px] relative justify-start text-black text-sm font-normal font-['Poppins'] leading-[19px]">
          Looking for high-performance display technology products and
          solutions? Connect with us to get a customized quote tailored to your
          needs.
        </p>
      </div>
      <div className="px-6 lg:px-8 md:pt-14 pt-8 pb-10 max-w-7xl m-auto book-demo-page">
        <div className="max-w-2xl mx-auto text-center mb-5 md:mb-8">
          <h2 className="relative flex justify-center text-black md:text-[30px] text-[24px] font-semibold font-['Poppins'] leading-[48px]">
            Request a Quote Now
          </h2>
          <p className="md:w-[520px] mx-auto text-center justify-start text-black text-xs leading-5 md:text-base font-normal font-['Poppins'] md:leading-[30.40px]">
            Fill in your details, and our team will provide the best pricing and
            solutions for your business or educational institution.
          </p>
        </div>
        <iframe
          src="/quote-form.html"
          title="outer-iframe"
          className="w-full lg:h-[840px] h-[1120px] search-iframe"
          style={{ border: "none" }}
          allowFullScreen
        ></iframe>
      </div>
      <Footer />
      <ScrollToTopButton />
      <WhatsAppMsg />
    </>
  );
};

export default GetQuote;
